import storage from 'local-storage-fallback'; 

const store = (profileId, data) => {
	const dataString = JSON.stringify(data);
	storage.setItem(`omneo:shapesclient:${profileId}`, dataString);
}

const clear = (profileId) => {
	storage.removeItem(`omneo:shapesclient:${profileId}`);
}

export default {
	getInitialData(profileId){
		const cachedData = storage.getItem(`omneo:shapesclient:${profileId}`);
		try{
			if(!cachedData){throw false}
			const parsed = JSON.parse(cachedData);
			if(parsed.profile.data.id !== profileId){throw false}
			return {
				...parsed,
				action: "init"
			}
		}catch(e){
			storage.removeItem(`omneo:shapesclient:${profileId}`);
			return false
		}
	},
	middleware({ getState }) {
		return next => action => {
			next(action);

			try{
				const dataString = JSON.stringify(getState());
				storage.setItem(`omneo:shapesclient:${this.profile_id}`, dataString);
			}catch(e){}
		}
	}
}